import Privacy from "../Sections/Privacy/Privacy"

const PrivacyPolicy = () => {
  return (
    <Privacy />
  )
}

export default PrivacyPolicy;